// extracted by mini-css-extract-plugin
export default {"projectSummaryContainer":"projectIntake_projectSummaryContainer__BbqbM"};